import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import {
  Button,
  Collapse,
  Container,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Jumbotron,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem, UncontrolledCollapse, CardBody, Card 
} from 'reactstrap';
import AdminPanel from './AdminPanel';
import '@fortawesome/fontawesome-free/css/all.css';

interface WelcomeProps {
  isAuthenticated: boolean;
  authButtonMethod: any;
  user: any;
}

interface WelcomeState {
  isOpen: boolean;
}

function WelcomeContent(props: WelcomeProps) {
  // If authenticated, greet the user
  if (props.isAuthenticated) {
    return (
      <div>
        <h4>Welcome {props.user.displayName}!</h4>
        <p>Use the navigation bar at the top of the page to get started.</p>
      
      
        <div></div>
      
      
      </div>
     
    );
  }

  // Not authenticated, present a sign in button
  return <Button color="primary" onClick={props.authButtonMethod}>Click here to sign in</Button>;
}

export default class Welcome extends React.Component<WelcomeProps, WelcomeState> {
  
  
  render() {
    const divStyle = {
      backgroundImage: 'url(img/img_03.jpg)',
      backgroundSize: '100%'
      };
      
    return (
     <div>
       
       
        <div className="animated fadeIn websitepages">
      <div className="overlay"></div>
        <div className="parallaximage aboutimg text-center  whitetext   " style={divStyle}>
          <div className="container">
            <div className="col-lg-12 col-md-12 col-sm-12 headerareas overlaytext">
              <h1 className="sans_fontheader font-weight-bold">Administration</h1>
              <div className="text-center"></div>
              <div className="clearfixblock"></div>
            </div>
            <div className="clearfixblock"></div>
          </div>
          <div className="clearfixblock"></div>
        </div>
        <div className="pb-5 overlaybackground">
          <div className="container ptb-40">
              <AdminPanel/>
          </div>
          <div className="clearfixblock"></div>
        </div>
      </div>
       
   </div>
    );
  }
}

